export const searchState = {
  name: '',
  sortName: '',
  genre: '',
};
